import { account } from "utils/axiosInstances";
import { camelize, snakeify } from "utils/objectUtilities";

const URL = "/contractor-types";

export const fetchContractorTypes = async () => {
  try {
    const response = await account.get(URL);
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};

export const createContractorType = async (data) => {
  try {
    const response = await account.post(URL, snakeify(data));
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};
